import {Inject, Injectable, Optional} from '@angular/core';
import {environment} from "../../environments/environment";
import {SynapiPredicate} from "../models/Synapi/SynapiPredicate";
import {ApiService} from "./api.service";
import {SynapiItem} from "../models/Synapi/SynapiItem";
import {SynapiListItems} from "../models/Synapi/SynapiListItems";
import {SynapiFilters} from "../models/Synapi/SynapiFilters";
import {SynapiSelection} from "../models/Synapi/SynapiSelection";
import {LANG} from "../tokens/lang.token";
import {LanguageService} from "./language.service";

@Injectable({
  providedIn: 'root'
})
export class SynapiService {
  public mapPredicate: SynapiPredicate = new SynapiPredicate();
  public listPredicate: SynapiPredicate = new SynapiPredicate();
  public filterPredicate: SynapiPredicate = new SynapiPredicate();
  constructor(public langService: LanguageService, public api : ApiService) {}

  getUrl(endpoint:string){
    return `${environment.synapiApiUrl}${endpoint}`;
  }

  get(endpoint:string, predicate : SynapiPredicate): Promise<any>{
    predicate.lang = this.langService.current;
    return this.api.get(this.getUrl(endpoint),predicate,true,true);
  }

  getSmallItems(predicate : SynapiPredicate): Promise<SynapiListItems> {
    return this.get("SmallItems",predicate);
  }

  async getItems(predicate: SynapiPredicate): Promise<SynapiListItems> {
    if (predicate.scids) {
      const p = Object.assign(new SynapiPredicate(), predicate);
      p.ids = predicate.scids;
      await this.getSmallItems(p).then((listItems) => {
        if(listItems.items) {
          predicate.ids = listItems.items.map((li) => li.ExternalId).slice(0,50);
        }
      })
    }
    return this.get("Items", predicate);
  }

  getItem(predicate : SynapiPredicate): Promise<SynapiItem> {
    return this.get("Item",predicate);
  }

  getFilters(predicate : SynapiPredicate): Promise<SynapiFilters> {
    return this.get("Filters",predicate);
  }

  getSelection(predicate : SynapiPredicate): Promise<SynapiSelection> {
    return this.get("Criteria",predicate);
  }
}
